export default function init() {
	const downloaders = document.querySelectorAll('.js-file-downloader');

	downloaders.forEach(downloader => {
		const select = downloader.querySelector('.js-file-downloader-select');

		if (!select) return;

		select.addEventListener('change', () => {
			const url = select.value;
			downloader.querySelector('.js-file-downloader-link').href = url;
		});
	});
}